module.exports = __webpack_public_path__ + "b6de897f4256fc907e68c69bff1f3e99.MP3";